import Emphasis from './Emphasis';

/**
 * Shared section scaffolding: numbered mono label + big display title.
 * `title` may contain <em>…</em> for the italic serif accent.
 */
export function SectionHeader({ index, label, title, description, action }) {
  return (
    <div className="reveal mb-12 lg:mb-16 grid lg:grid-cols-12 gap-6 items-end">
      <div className="lg:col-span-8">
        <p className="label flex items-center gap-3 mb-5">
          <span className="text-accent">{index}</span>
          <span className="h-px w-8 bg-line-2" aria-hidden="true" />
          {label}
        </p>
        <h2 className="section-title">
          <Emphasis text={title} />
        </h2>
      </div>
      {(description || action) && (
        <div className="lg:col-span-4 lg:pb-2 flex flex-col gap-4 lg:items-end lg:text-right">
          {description && (
            <p className="text-sm text-muted leading-relaxed max-w-xs">{description}</p>
          )}
          {action}
        </div>
      )}
    </div>
  );
}

export function PageSection({ id, children, className = '' }) {
  return (
    <section
      id={id}
      className={`relative scroll-mt-20 px-6 lg:px-10 py-20 lg:py-28 ${className}`}
    >
      <div className="max-w-page mx-auto">{children}</div>
    </section>
  );
}
